export function useReadingSidebarDefault() {
  const sidebarExpanded = ref<boolean>(true)

  onMounted(() => {
    if (isNarrowTabletViewport()) {
      sidebarExpanded.value = false
    }
  })

  // Mobile has no collapsed sidebar rail, so force it open. Otherwise the toc view can stay stuck after collapsing on tablet
  const isMobile = useMediaQuery(`(max-width: ${MOBILE_MAX_WIDTH}px)`)
  watch(isMobile, (mobile) => {
    if (mobile) {
      sidebarExpanded.value = true
    }
  })

  return {
    sidebarExpanded,
  }
}
